import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { useDevice } from '../Device';
import { InfoIcon } from '../InfoIcon';
import styles from './WithInfoIcon.module.scss';
/**
 * Adds an info icon with info after the content. Used for decorating a text section
 * with an info icon.
 */ export function WithInfoIcon(props) {
    const { children, info, showInfo = true, infoTestId, testId, as, className, size, placement, disableArrow } = props, rest = _object_without_properties(props, [
        "children",
        "info",
        "showInfo",
        "infoTestId",
        "testId",
        "as",
        "className",
        "size",
        "placement",
        "disableArrow"
    ]);
    const { isMobileDevice } = useDevice();
    const RootElement = as || 'div';
    return /*#__PURE__*/ _jsxs(RootElement, _object_spread_props(_object_spread({}, rest), {
        className: cn(styles.root, className),
        "data-testid": testId,
        children: [
            children,
            showInfo && !isMobileDevice && /*#__PURE__*/ _jsx(InfoIcon, {
                placement: placement,
                disableArrow: disableArrow,
                className: styles.icon,
                info: info,
                testId: infoTestId,
                size: size,
                onClick: (e)=>{
                    e.stopPropagation();
                    e.preventDefault();
                }
            })
        ]
    }));
}
